import $ from 'jquery';
import Parallax from './Parallax';
import BackgroundImage from './BackgroundImage';

export default class Banner {
  constructor(element) {
    this.element = element;
    this.$element = $(element);
    this.modify();
    this.ready();
  }

  modify() {
    this.$element.find('.node').each((a, node) => {
      // Add parallax background image.
      $('.node-upper-image .field-image', node).each((b, image) => {
        node.BackgroundImage = new BackgroundImage(image);
        node.Parallax = new Parallax(image);
      });

      // Remove redirect on term banners
      $('.node-header a', node).children().unwrap();
    });
  }

  ready() {
    return this.$element.addClass('ready');
  }
}
